module.exports = __webpack_public_path__ + "static/media/spicy-guac-teen-hero-mobile.beed01ad.jpg";